__turbopack_context__.v({
  "actions": "CContactForm-module__WZJtdW__actions",
  "fieldError": "CContactForm-module__WZJtdW__fieldError" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["errorText"],
  "fieldRow": "CContactForm-module__WZJtdW__fieldRow",
  "fieldsGrid": "CContactForm-module__WZJtdW__fieldsGrid",
  "fieldsSection": "CContactForm-module__WZJtdW__fieldsSection",
  "form": "CContactForm-module__WZJtdW__form" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["form"],
  "formTitle": "CContactForm-module__WZJtdW__formTitle" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["formTitle"],
  "intro": "CContactForm-module__WZJtdW__intro",
  "mapWrap": "CContactForm-module__WZJtdW__mapWrap",
  "root": "CContactForm-module__WZJtdW__root",
  "sectionHeader": "CContactForm-module__WZJtdW__sectionHeader",
});
